import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Box, Card, CardContent, Typography, Grid } from '@material-ui/core';
import cn from 'classnames';
import { ru } from 'locale';
import { Page, AppBar, ScreenLoader, EmptyState } from 'components';
import { anketsStore, companyAffiliatesStore } from 'stores';
import { NoData as NoDataBg } from 'resources/images';
import useStyles from './CompanyAffiliatesScreen.styles';

const CompanyAffiliatesScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { fetchState, affiliates } = companyAffiliatesStore;
  const hasAffiliates = affiliates.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        companyAffiliatesStore.getAffiliates(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderCompanyAffiliate = affiliate => {
    return (
      <Box key={affiliate.inn} my={1}>
        <Card square>
          <CardContent>
            <Box mb={1}>
              <Typography variant="body1">{affiliate.organizationName}</Typography>
              <Typography variant="body2" color="textSecondary">
                {`${ru.inn}: ${affiliate.inn}`}
              </Typography>
            </Box>
            <Typography variant="body1">{`${ru.generalDirector}:`}</Typography>
            <Box mb={1} ml={2}>
              <Typography variant="body2" color="textSecondary">
                {affiliate.directorName}
              </Typography>
            </Box>

            <Typography variant="body1">{ru.heads}</Typography>

            {affiliate.heads.map(head => {
              return (
                <Box key={head} mb={1} ml={2}>
                  <Typography component="div" variant="body2" color="textSecondary">
                    {head}
                  </Typography>
                </Box>
              );
            })}
          </CardContent>
        </Card>
      </Box>
    );
  };

  const renderCompanyAffiliates = () => {
    if (!hasAffiliates) {
      return (
        <EmptyState
          image={{ source: NoDataBg, alt: ru.listOfCompanyAffiliates }}
          title={ru.emptyList(ru.listOfCompanyAffiliates)}
        />
      );
    }

    return affiliates.map(affiliate => renderCompanyAffiliate(affiliate));
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }} className={classes.root}>
      <Grid container direction="column">
        <AppBar title={ru.companyAffiliates} onNavButtonClick={handleBackClick} />

        {fetchState === 'pending' && <ScreenLoader />}

        <Grid
          container
          item
          direction="column"
          justify={hasAffiliates ? 'flex-start' : 'center'}
          className={cn({
            [classes.content]: !hasAffiliates,
          })}
        >
          {fetchState === 'fulfilled' && renderCompanyAffiliates()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default CompanyAffiliatesScreen;
